import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Swal from 'sweetalert2';
import { getProfileInformation, putProfileInformation } from 'actions/profile';
import { setPageTitle } from 'actions/header';
import { addError } from 'actions';
import { Spinner } from 'UI';
import { Button, translate } from '@haldor/ui';
var Profile = /*#__PURE__*/function (_Component) {
  function Profile(props) {
    var _this;
    _classCallCheck(this, Profile);
    _this = _callSuper(this, Profile, [props]);
    _defineProperty(_this, "UNSAFE_componentWillMount", function () {
      _this.props.setPageTitle(_this.props.translate('Your information'));
      _this.props.getProfileInformation().then(function () {
        _this.mapProfileToState();
        _this.setState({
          loading: false
        });
      });
    });
    _defineProperty(_this, "onInputChange", function (field, event) {
      var values = _this.state.values;
      values[field] = event.target.value;
      _this.setState({
        values: values
      });
    });
    _defineProperty(_this, "onSubmit", function () {
      var error = _this.validateForm();
      var translate = _this.props.translate;
      if (error === false) {
        var values = _this.state.values;
        _this.props.putProfileInformation(values).then(function () {
          Swal.fire(translate('Information saved'));
        });
      }
    });
    _defineProperty(_this, "validateEMail", function (Mail) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line
      return re.test(Mail);
    });
    _defineProperty(_this, "mapProfileToState", function () {
      if (_this.props.profile != null) {
        var values = {
          Street: _this.props.profile != null ? _this.props.profile.street : '',
          Postal: _this.props.profile != null ? _this.props.profile.postal : '',
          City: _this.props.profile != null ? _this.props.profile.city : '',
          Phone: _this.props.profile != null ? _this.props.profile.phone : '',
          Mail: _this.props.profile != null ? _this.props.profile.mail : '',
          GuardianId: _this.props.profile != null ? _this.props.profile.guardianId : '',
          Synced: _this.props.profile != null ? _this.props.profile.synced : false
        };
        _this.setState({
          values: values
        });
      }
    });
    _defineProperty(_this, "validateForm", function () {
      var values = _this.state.values;
      var translate = _this.props.translate;
      var error = false;
      if (values.Postal != '' && values.Postal != null) {
        if (isNaN(values.Postal)) {
          error = true;
          _this.props.addError(translate('Enter valid ZIP code'), 'notice');
        } else if (values.Postal < 10000 || values.Postal > 99999) {
          error = true;
          _this.props.addError(translate('Enter valid ZIP code'), 'notice');
        }
      } else {
        error = true;
        _this.props.addError(translate('Enter valid ZIP code'), 'notice');
      }
      if (values.City != '' && values.City != null) {
        values.City = values.City.trim();
      } else {
        error = true;
        _this.props.addError(translate('Enter city'), 'notice');
      }
      if (values.Street != '' && values.Street != null) {
        values.Street = values.Street.trim();
      } else {
        error = true;
        _this.props.addError(translate('Enter street name'), 'notice');
      }
      if (values.Phone != '' && values.Phone != null) {
        values.Phone = values.Phone.replace('-', '');
        values.Phone = values.Phone.trim();
        values.Phone = values.Phone.replace(/\s/g, '');
        if (isNaN(values.Phone)) {
          error = true;
          _this.props.addError(translate('Enter valid phone number'), 'notice');
        }
      } else {
        error = true;
        _this.props.addError(translate('Enter valid phone number'), 'notice');
      }
      if (values.Mail != '' && values.Mail != null) {
        values.Mail = values.Mail.trim();
        var validMail = _this.validateEMail(values.Mail);
        if (!validMail) {
          error = true;
          _this.props.addError(translate('Enter valid e-mail'), 'notice');
        }
      } else {
        error = true;
        _this.props.addError(translate('Enter valid e-mail'), 'notice');
      }
      _this.setState({
        values: values
      });
      return error;
    });
    _this.state = {
      values: {
        Street: props.profile != null ? props.profile.street : '',
        Postal: props.profile != null ? props.profile.postal : '',
        City: props.profile != null ? props.profile.city : '',
        Phone: props.profile != null ? props.profile.phone : '',
        Mail: props.profile != null ? props.profile.mail : '',
        GuardianId: props.profile != null ? props.profile.guardianId : '',
        LCID: props.profile != null ? props.profile.lcid : ''
      },
      loading: true
    };
    return _this;
  }
  _inherits(Profile, _Component);
  return _createClass(Profile, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      if (this.state.loading) {
        return /*#__PURE__*/React.createElement("div", {
          className: "form-container form-create_task",
          style: {
            marginTop: '2em'
          }
        }, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }
      var translate = this.props.translate;
      return /*#__PURE__*/React.createElement("div", {
        className: "page form-container form-create_task"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form form-component form-container-width"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row input"
      }, /*#__PURE__*/React.createElement("label", null, translate('Phone')), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", {
        type: "text",
        placeholder: "Telefon",
        onChange: function onChange(event) {
          _this2.onInputChange('Phone', event);
        },
        value: this.state.values.Phone,
        disabled: this.state.values.Synced
      }))), /*#__PURE__*/React.createElement("div", {
        className: "form-row input"
      }, /*#__PURE__*/React.createElement("label", null, translate('E-Mail'), " ", this.state.values.Synced ? '' : /*#__PURE__*/React.createElement("span", {
        style: {
          fontWeight: 400
        }
      }, "(", translate('If you wish to update your email, please contact the school and follow their instructions.'), ")")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", {
        type: "text",
        placeholder: translate('E-Mail'),
        maxLength: 250,
        onChange: function onChange(event) {
          _this2.onInputChange('Mail', event);
        },
        value: this.state.values.Mail,
        disabled: true
      }))), /*#__PURE__*/React.createElement("div", {
        className: "form-row input"
      }, /*#__PURE__*/React.createElement("label", null, translate('Street address')), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", {
        type: "text",
        placeholder: translate('Street address'),
        maxLength: 80,
        onChange: function onChange(event) {
          _this2.onInputChange('Street', event);
        },
        value: this.state.values.Street,
        disabled: this.state.values.Synced
      }))), /*#__PURE__*/React.createElement("div", {
        className: "form-row input"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row-half"
      }, /*#__PURE__*/React.createElement("label", null, translate('ZIP Code')), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", {
        type: "number",
        placeholder: translate('ZIP Code'),
        max: 99999,
        min: 10000,
        onChange: function onChange(event) {
          _this2.onInputChange('Postal', event);
        },
        value: this.state.values.Postal,
        disabled: this.state.values.Synced
      }))), /*#__PURE__*/React.createElement("div", {
        className: "form-row-half last"
      }, /*#__PURE__*/React.createElement("label", null, translate('City')), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", {
        type: "text",
        placeholder: translate('City'),
        maxLength: 50,
        onChange: function onChange(event) {
          _this2.onInputChange('City', event);
        },
        value: this.state.values.City,
        disabled: this.state.values.Synced
      })))), /*#__PURE__*/React.createElement("div", {
        className: "form-row spacing submit",
        style: {
          paddingTop: '2rem'
        }
      }, this.state.values.Synced ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '1rem'
        }
      }, translate('This information is taken from information you have previously provided and cannot be edited here. If you wish to update your information, please contact the school and follow their instructions.')) : /*#__PURE__*/React.createElement(Button, {
        disabled: this.state.values.Synced,
        onClick: this.onSubmit
      }, translate('Save')))));
    }
  }]);
}(Component);
var mapStateToProps = function mapStateToProps(state) {
  return {
    profile: state.profile.profile,
    translate: translate(state.Languages.translations)
  };
};
export default connect(mapStateToProps, {
  addError: addError,
  getProfileInformation: getProfileInformation,
  putProfileInformation: putProfileInformation,
  setPageTitle: setPageTitle
})(Profile);